import routes from 'common/constants/routing.constants';
import React, { useMemo } from 'react';

import history from 'customHistory';
import { inject, observer } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { SwitchAccountType } from '../SwitchAccountType';
import SocialMediaIcons from '../Menu/SocialMediaIcons';
import { LanguageSwitcher } from '../../../../LanguageSwitcher';
import { NavbarElement } from './NavbarElement';
import { S } from './style';
import { sectionOne, sectionThree, sectionTwo } from './sections';

const SiteNavbar = ({ location, t }) => {
  const isTradingPage = useMemo(
    () => history.location.pathname === routes.trading.path,
    [history]
  );

  return (
    <S.Navbar data-testid="trading-menu">
      {sectionOne.map((props) => (
        <NavbarElement
          key={props.path}
          {...props}
          t={t}
          isActive={location.pathname === props.path}
        />
      ))}
      <S.SiteNavbarDivider />
      {sectionTwo.map((props) => (
        <NavbarElement
          key={props.path}
          {...props}
          t={t}
          isActive={location.pathname === props.path}
        />
      ))}
      <S.SiteNavbarDivider />
      {sectionThree.map((props) => (
        <NavbarElement
          key={props.path}
          {...props}
          t={t}
          isActive={location.pathname === props.path}
        />
      ))}
      <S.SiteNavbarDivider />

      <S.SwitchAccountHeading>{t('common.accountType')}</S.SwitchAccountHeading>
      <S.SwitchAccountTypeWrapper isTradingPage={isTradingPage}>
        <SwitchAccountType />
      </S.SwitchAccountTypeWrapper>
      <SocialMediaIcons />
      <S.LanguageSwitcherContainer>
        <LanguageSwitcher placement="bottom-start" />
      </S.LanguageSwitcherContainer>
    </S.Navbar>
  );
};

export default compose(
  inject('AppStore', 'ProfileStore'),
  withTranslation()
)(withRouter(observer(SiteNavbar)));
